import { createSlice } from "@reduxjs/toolkit";
import { NotificationType } from "../../components/notifications/notification-component";

interface SpinnerConfiguration {
  enable?: boolean;
  label?: string;
}

export interface SpinnerState {
  spinner: SpinnerConfiguration;
}

export const initialState: SpinnerState = {
  spinner: {
    enable: false,
    label: "",
  },
};

const spinnerSlice = createSlice({
  name: "spinnerSlice",
  initialState,
  reducers: {
    showSpinner(state, action) {
      state.spinner = {
        enable: true,
        label: action.payload.label,
      };
    },
    hideSpinner(state) {
      state.spinner = {
        enable: false,
        label: "",
      };
    },
  },
});

export const { showSpinner, hideSpinner } = spinnerSlice.actions;

export default spinnerSlice.reducer;
